export const PROVIDER_NAME = "ViewJob";
